const { Outlet } = require("react-router-dom");

const RWBCISOutlet = () => {
    return (
        <Outlet />
    );
}

export default RWBCISOutlet;
